import ssoImg1 from "./../../../../assets/images/tabimg-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/tabimg-2.png"; // Adjust the path as necessary

function MedicalTab() {
  return (
    <>
      <div className="service-title font-700 mb-3">SEAFARER <span className="text-orange-ef3e33 font-400 text-uppercase">Medical PRACTITIONERS </span></div>
      
      <div className="row g-3 g-sm-4 g-md-4 g-lg-5">
        
        {/* hide left side imge column
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        <div className="col-lg">
          <div className="">
            {/* <p className="mb-4 font-18 font-900">
           ​​​Boating - Safety Surveys
          </p> */}
          
          <p className="mb-4">Part 5 of the <a href="#">Merchant Shipping (Training, Certification and Safe Manning) Regulations, 2021,</a> (the Regulations) requires that all medical practitioners performing the medical examinations required under the Merchant Shipping Act, 1951, as amended be approved in accordance with the Regulations.</p>
          <p className="mb-4">This process, QMS-OP-1003 - Approval of Medical Practitioners, gives effect to the provisions of these Regulations and are applicable to all medical practitioners seeking to be so approved. The process comprises of the following documents which covers the procedures, forms checklists, etc. necessary for a full approval:</p>
          </div>
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >Approval of Medical Practitioners​​
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">Sets out the primary requirements for the approval of the Medical Practitioners, including the process flows and the associated document.</p>

                  <ul class="green-star-ul">
                    <li><a href="#">QMS-OP-1003 – Approval of Medical Practitioners​​</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button "
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="true"
                  aria-controls="blackTabTwo"
                >Requirements for Approval of Medical Practitioners
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse show"
                
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">Sets detailed compulsory approval requirements for Medical Practitioners</p>
                  <ul class="green-star-ul">
                    <li><a href="#">QMS-OG-1003.1 – Requirements for Approval of Medical Practitioners</a></li>
                  </ul>
                   </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >Application for Approval or Re-Approval
                </button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">Checklist to be used by the Medical Practitioners to compile their application for submission</p>
                  <ul class="green-star-ul">
                    <li><a href="#">QMS-OC-1003.1 - Application for Approval or Re-Approval checklist</a></li>
                  </ul>
             </div>
              </div>
              
            </div>

            <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTabFour"
                aria-expanded="false"
                aria-controls="blackTabFour">
            Audit Checklist and Aide Memoir
        </button>
    </h2>
    <div id="blackTabFour"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Checklist used for a Medical Practitioner's venue inspection and audit during the approval or re-approval process. This checklist is also used when doing Adhoc medical practitioners audit</p>

            <ul class="green-star-ul">
                <li><a href="#">QMS-OC-1003.2 – Audit Checklist and Aide Memoir</a></li>
            </ul>
        </div>
    </div>
</div>
            
    <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab5"
                aria-expanded="false"
                aria-controls="blackTab5">
            Seafarer medical examination records 
        </button>
    </h2>
    <div id="blackTab5"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Templates to be used by medical practitioners when sending their periodic medical returns</p>
            <ul class="green-star-ul">
                <li><a href="#">QMS-OT-1003.5 – Seafarer medical examination records </a> Kindly use Chrome Browser to open the document </li>
            </ul>
        </div>
    </div>
</div>
   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab6"
                aria-expanded="false"
                aria-controls="blackTab6">Application for Colour and Form Vision Test
        </button>
    </h2>
    <div id="blackTab6"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Form to be completed by a seafarer when applying for the eyesight medical examinations in a SAMSA office</p>
              <ul class="green-star-ul">
                    <li><a href="#">QMS-OF-1003.6 – Application for Colour and Form Vision Test</a></li>
                  </ul>		

        </div>
    </div>
</div>
<p className="mb-4">The Medical Practitioner(s), in submitting their application for approval, or re-approval, shall compile their applications as guided by QMS-OC-1003.1 – Checklist for submission of information together with the <a href="">application for service form</a>  and submit to the nearest SAMSA Office.</p>
<p className="mb-4">To find out if a Medical Practitioner is approved, you may check the list of approved Medical Practitioners here:</p>
<ul class="green-star-ul">
                    <li><a href="">Approved Medical Practitioners, by Practice</a></li>
                    <li><a href="">Approved Medical Practitioners, by Area</a></li>
</ul>
<p className="mb-4">Enquiries regarding the List of Approved Medical Practitioners shall be directed to <a href="institutions@samsa.org.za">institutions@samsa.org.za</a></p>
  

            
          </div>
        </div>
        
        
      </div>


    </>
  );
}

export default MedicalTab;